import DressUpBook from '~/pages/DressUpBook/pages/index/reducers'
import DressUpBookRank from '../pages/DressUpBook/pages/rank/reducers'
import DressUpBookRule from '../pages/DressUpBook/pages/rule/reducers'
import DressUpBookLevel from '../pages/DressUpBook/pages/level/reducers'

export default {
  Animal_Butterfly: DressUpBook,
  Animal_Parrot: DressUpBookRank,
  DressUpBookRule,
  DressUpBookLevel,
}
